var _circle, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F61A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32.001,
    cy: 32,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M45.588 45.434c1.273-1.887-2.314-2.602-2.819-5.463s2.624-4.761.781-6.099c-2.206-1.604-6.013.574-8.994-1.592.374 2.119 2.559 4.119 5.882 3.533 0 0-2.098 1.309-1.477 4.83.62 3.521 3.04 4.033 3.04 4.033-3.323.586-4.693 3.212-4.319 5.33 2.06-3.055 6.382-2.311 7.906-4.572z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fill: "#FF717F",
    d: "M54.962 20.916c-4.181-1.048-8.226.393-9.035 3.216-.81 2.822 1.924 5.961 6.105 7.009 4.183 1.048 8.227-.391 9.035-3.216.81-2.824-1.923-5.962-6.105-7.009zM21.903 29.72c-2.435-2.941-8.303-3.016-13.115-.164-4.812 2.851-6.739 7.546-4.308 10.487 2.433 2.94 8.306 3.014 13.118.162 4.813-2.852 6.737-7.546 4.305-10.485z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.154 17.678c5.531 7.101 13.885 5.625 16.654-2.937.135-.431-.436-.512-1.174-.844-3.584 4.003-10.367 4.888-14.666 2.588-.579.563-1.086.835-.814 1.193zM10.792 21.974c5.532 7.1 13.886 5.625 16.655-2.937.135-.43-.436-.512-1.174-.844-3.584 4.003-10.368 4.889-14.665 2.588-.581.562-1.088.834-.816 1.193z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F61A);
export default __webpack_public_path__ + "static/media/1f61a.b6e1595ed4cb42c3129988482a0a86e1.svg";
export { ForwardRef as ReactComponent };